import { Paper } from '@material-ui/core';
import dayjs from 'dayjs';
import React from 'react';
import styles from './ThankYou.module.scss';

const ThankYou = ({ salesAgentName, appointmentTime }) => {
	return (
		<Paper className={styles.thankYouWrapper}>
			<h1 className={styles.title}>You are set!</h1>

			<p className={styles.content}>
				You have an appointment with {salesAgentName} on the{' '}
				{dayjs(appointmentTime).format('DD')} of{' '}
				{dayjs(appointmentTime).format('MMMM')}{' '}
				{dayjs(appointmentTime).format('YYYY')} at{' '}
				{dayjs(appointmentTime).format('hh')}:
				{dayjs(appointmentTime).format('mm')}{' '}
				{dayjs(appointmentTime).format('a')}. See you soon!
			</p>
		</Paper>
	);
};

export default ThankYou;
